module.exports = __webpack_public_path__ + "static/img/iconfont.4c98063.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/iconfont.svg?t=1585034858718
// module id = 562
// module chunks = 8